import type { Language } from '@luna/i18n';

export const handleLanguageChange = (language: Language, currentLanguage: string | Language) => {
    const urlParams = new URLSearchParams(window.location.search);

    if (language === currentLanguage) {
        return;
    }

    urlParams.set('lang', language);
    window.location.search = urlParams.toString();
};
